(() => {
  class AccordionControls extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.abort) return;
        this.root = this.closest('product-info, [id^="ProductInfo-"], section[id^="MainProduct-"]');
        if (!this.root) return;
        this.abort = new AbortController();
        this.root.addEventListener('click', event => {
          const summary = event.target.closest('.product__accordion summary');
          const details = summary?.closest('details');
          if (!details || !this.root.contains(details)) return;
          event.preventDefault();
          event.stopPropagation();
          details.open = !details.open;
        }, { capture: true, signal: this.abort.signal });
        const restore = () => this.root.querySelectorAll('.product__accordion.quick-add-hidden').forEach(accordion => accordion.classList.remove('quick-add-hidden'));
        this.observer = new MutationObserver(restore);
        this.observer.observe(this.root, { childList: true, subtree: true });
        restore();
      });
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.abort = null; }
  }
  if (!customElements.get('beleaev-accordion-controls')) customElements.define('beleaev-accordion-controls', AccordionControls);
})();
